import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=db445366"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RecipesCategories: require('/vercel/path0/components/recipesCategories.vue').default,VideoEmbed: require('/vercel/path0/components/ui/videoEmbed.vue').default,Block: require('/vercel/path0/components/ui/block.vue').default})
